export const DEFAULT_PROPERTY_IMAGE = 'https://as-images.imgix.net/properties-no-image.png';

export const DEFAULT_PROPERTY_IMAGE_NEW = 'https://as-images.imgix.net/default-kato-image.png';
